<div *ngIf="hero"
     class="card">
  <img [src]="hero.image">
  <div class="container">
    <h2>{{hero.name | uppercase}} Details</h2>
    <div><span>id: </span>{{hero.id}}</div>
    <div><span>species: </span>{{hero.species}}</div>
    <div><span>status: </span>{{hero.status}}</div>
    <div>
      <label>name: <input [(ngModel)]="hero.name"
               placeholder="name" />
      </label>
    </div>
    <button (click)="goBack()">go back</button>
  </div>
</div>
